import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const QuestionCardHeader = ({ groupName, cardCollapsed, setCardCollapsed, cardHasErrorIn }) => (
  <div className="question-card-header">
    {groupName && <h2 className="card-group">{groupName}</h2>}
    <button className="show-hide-question-card" type="button" hidden={ cardHasErrorIn } onClick={ () => setCardCollapsed(!cardCollapsed) }>
      <FontAwesomeIcon icon="chevron-up" className={ `chevron-icon ${ cardCollapsed ? 'left' : 'right' }` } />
      <FontAwesomeIcon icon="chevron-up" className={ `chevron-icon ${ cardCollapsed ? 'right' : 'left' }` } />
      <span>{cardCollapsed ? 'Expand' : 'Collapse'}</span>
    </button>
  </div>);

QuestionCardHeader.propTypes = {
  cardCollapsed: PropTypes.bool.isRequired,
  cardHasErrorIn: PropTypes.bool.isRequired,
  setCardCollapsed: PropTypes.func.isRequired,
  groupName: PropTypes.string
};

QuestionCardHeader.defaultProps = {
  groupName: '',
};

export default QuestionCardHeader;
